module.exports = __webpack_public_path__ + "static/media/mascote-mickey@2x.d4588320.jpg";